// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"66":"c8b3c697","1258":"c8b3c697","3916":"c8b3c697","5143":"c8b3c697","7891":"c8b3c697","8802":"c8b3c697","9165":"c8b3c697","9457":"c8b3c697"}[chunkId] + ".chunk.css";
};